<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button defaultHref="/call/dashboard" text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title>Reservation Requests</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-refresher slot="fixed" (ionRefresh)="loadData($event)">
    <ion-refresher-content pullingIcon="caret-down" pullingText="Pull to refresh" refreshingSpinner="circles"
      refreshingText="Refreshing...">
    </ion-refresher-content>
  </ion-refresher>
    <p class="ion-text-center ion-margin-top" *ngIf="!reservs.length">No services made.</p>
    <ion-list class="list" *ngIf="reservs.length">
      <ion-item-sliding *ngFor="let reserv of reservs; let i = index">
        <ion-item>
          <div class="information">
            <ion-badge *ngIf="getStatus(reserv)" color="getStatus(reserv).color">{{ getStatus(reserv).title
              }}</ion-badge>
            <h5>{{ reserv.nomeCliente }}</h5>
            <p>
              <ion-icon name="call"></ion-icon> {{ reserv.celular }}
            </p>
            <span style="display: flex;">
              <ion-icon name="calendar"></ion-icon> <span style="margin-right: 5px;">{{ reserv.dataReservaCliente &&
                !reserv.transformedIntoWalkin ? (reserv.dataReservaCliente | date: 'short') : 'Walk-in' }}</span>
              <ion-badge *ngIf="reserv.status === 0 && reserv.dataReservaCliente && !reserv.transformedIntoWalkin"
                item-end color="success" style="margin-bottom: 5px;">
                Pending
              </ion-badge>
            </span>
            <div style="display: flex; flex-direction: column;">
              <ion-badge item-end color="warning" style="margin-bottom: 5px;width: 50%;"
                *ngFor="let servico of reserv.servicos">
                {{ getServiceDescription(servico) }}
              </ion-badge>
            </div>
            <p>
              <ion-icon name="cut"></ion-icon> {{ reserv.restaurante.textoDesconto }}
            </p>
            <p *ngIf="reserv.observation">
              <ion-icon name="chatbubbles"></ion-icon> {{ reserv.observation }}
            </p>
            <p *ngIf="reserv.transformedIntoWalkin">
              <ion-icon name="warning" slot="start"></ion-icon>
              <span class="no-show-warning">This reservation has turned into a walk-in</span>
            </p>
          </div>
          <div style="display: flex;
          flex-direction: column;">
            <ion-badge *ngIf="reserv.quantidadePessoas > 0" item-end color="secondary" style="margin-bottom: 5px;">
              {{ reserv.quantidadePessoas <= 1 ? 'Person' : 'People' }}: {{ reserv.quantidadePessoas }} </ion-badge>
                <div class="flags">
                  <ion-img *ngIf="reserv.idiomas.includes(Languages.English)" src="assets/English.svg" class="ico"
                    alt="" />
                  <ion-img *ngIf="reserv.idiomas.includes(Languages.Portuguese)" src="assets/Portuguese.svg" class="ico"
                    alt="" />
                  <ion-img *ngIf="reserv.idiomas.includes(Languages.Spanish)" src="assets/Spanish.png" class="ico"
                    alt="" />
                  <ion-img *ngIf="reserv.idiomas.includes(Languages.Mandarin)" src="assets/Mandarin.png" class="ico"
                    alt="" />
                  <ion-img *ngIf="reserv.idiomas.includes(Languages.French)" src="assets/French.png" class="ico"
                    alt="" />
                  <ion-img *ngIf="reserv.idiomas.includes(Languages.Italian)" src="assets/Italian.png" class="ico"
                    alt="" />
                  <ion-img *ngIf="reserv.idiomas.includes(Languages.Japanese)" src="assets/Japanese.png" class="ico"
                    alt="" />
                  <ion-img *ngIf="reserv.idiomas.includes(Languages.Arabic)" src="assets/Arabic.png" class="ico"
                    alt="" />
                  <ion-img *ngIf="reserv.idiomas.includes(Languages.German)" src="assets/German.png" class="ico"
                    alt="" />
                  <ion-img *ngIf="reserv.idiomas.includes(Languages.Russian)" src="assets/Russian.png" class="ico"
                    alt="" />
                  <ion-img *ngIf="reserv.idiomas.includes(Languages.Vietnamese)" src="assets/Vietnamese.png" class="ico"
                    alt="" />
                </div>
          </div>
          <div class="effect">
            <span></span>
          </div>
        </ion-item>
        <ion-item-options>
          <button *ngIf="reserv.dataReservaCliente && !reserv.transformedIntoWalkin" (click)="accept(reserv, i)"
            ion-button color="primary-yellow" icon-start>
            Accept Reservation
          </button>
          <button *ngIf="!reserv.dataReservaCliente || reserv.transformedIntoWalkin" (click)="accept(reserv, i)"
            ion-button color="primary" icon-start>
            Accept when guest arrives
          </button>
          <button (click)="denied(reserv, i)" ion-button color="danger" icon-start>
            Decline
          </button>
          <button
            *ngIf="(!reserv.dataReservaCliente || reserv.transformedIntoWalkin) && reserv.tipoComissao == 'COMISSAO_POR_PESSOA' "
            (click)="editReserv(reserv, i)" ion-button color="secondary" icon-start>
            Edit
          </button>
        </ion-item-options>
      </ion-item-sliding>

    </ion-list>

  <app-modal-component *ngIf="showModalEdit && reservSelected" (stateOpen)="showModalEdit = $event">
    <h2 class="title">Select the number of people that should be in this reservation</h2>
    <ion-item>
      <ion-label position="floating">Number People</ion-label>
      <ion-input type="number" [(ngModel)]="selectNumber"></ion-input>
    </ion-item>
    <button class="ion-margin-top button-bigger grey" (click)="confirmEdition()">Confirm Edition</button>
  </app-modal-component>
</ion-content>

<app-modal-component *ngIf="showModalFilter" (stateOpen)="showModalFilter = $event">
  <form [formGroup]="filterForm">
    <ion-item>
      <ion-label position="floating">Client name</ion-label>
      <ion-input type="text" formControlName="nomeCliente"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="floating">Begin date</ion-label>
      <ion-input type="datetime-local" formControlName="dataInicio"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="floating">End date</ion-label>
      <ion-input type="datetime-local" formControlName="dataFim"></ion-input>
    </ion-item>
  </form>
  <button class="ion-margin-top button-bigger grey" (click)="filterData()">Search</button>
</app-modal-component>

<ion-fab vertical="bottom" horizontal="end" slot="fixed" size="small">
  <ion-fab-button *ngIf="!isFiltered" color="dark" (click)="showFilter()">
    <ion-icon name="search"></ion-icon>
  </ion-fab-button>
  <ion-fab-button *ngIf="isFiltered" color="dark" (click)="loadData()">
    <ion-icon name="close"></ion-icon>
  </ion-fab-button>
</ion-fab>